import React, { ReactNode } from 'react';
import { Menu as MuiMenu } from '@mui/material';
import { OverridableStyles } from '~/utils/types.js';
import { PopoverOrigin } from '@mui/material/Popover/Popover.js';

export interface MenuProps extends OverridableStyles {
  open: boolean;
  children?: ReactNode;
  anchorEl: Element | null;
  onClose?: (e: React.MouseEvent) => void;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  invisibleBackdrop?: boolean;
}

const Menu: React.FC<MenuProps> = ({
  open,
  children,
  anchorEl,
  onClose,
  transformOrigin,
  anchorOrigin,
  invisibleBackdrop,
}) => {
  const invisibleBackdropStyleOverride = {
    '.MuiModal-backdrop': { background: 'none' },
  };

  return (
    <MuiMenu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      sx={invisibleBackdrop ? invisibleBackdropStyleOverride : undefined}
    >
      {children}
    </MuiMenu>
  );
};

export default Menu;
